import Layout from "../Layout";
import Dashboard from "../pages/Dashboard/Dashboard";
import Substore from "../pages/Users/Substore";
import Offers from "../pages/Offers/Offers";
import Profile from "../pages/Account/Profile";
import Auth from "../components/Auth";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ForgotPassword from "../pages/auth/ForgotPassword";
import NotFound from "../components/NotFound";
import CreateOrder from "../pages/Order/CreateOrder";
import { AuthProtected, ProtectedRoute } from "./protectedRoute";
import Earning from "../pages/Earning/Earning";
import CurrentMonth from "../pages/Earning/CurrentMonth";
import CurrentWeek from "../pages/Earning/CurrentWeek";
import Storesetting from "../pages/Settings/Storesetting";
import Deliverysettings from "../pages/Settings/Deliverysettings";
import Storetimesettings from "../pages/Settings/Storetimesettings";
import StoreReviews from "../pages/History/StoreReviews.jsx";
import ProductReview from "../pages/History/ProductReview.jsx";
import Category from "../pages/Menu/Category";
import ImportExportData from "../pages/Menu/ImportExportData";
import CancellationPolicy from "../pages/Settings/CancellationPolicy";
import BasicSettings from "../pages/Settings/BasicSettings";
import AllOrder from "../pages/Order/AllOrder";
import PendingOrder from "../pages/Order/PendingOrder";
import AcceptedOrder from "../pages/Order/AcceptedOrder";
import DeliveredOrder from "../pages/Order/DeliveredOrder";
import ReturnOrder from "../pages/Order/ReturnOrder";
import CancelOrder from "../pages/Order/CancelOrder";
import ReplaceOrder from "../pages/Order/ReplaceOrder";
import Sale from "../pages/Offers/Sale";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "../custom/ErrorPage";
import VerifyOtp from "../pages/auth/VerifyOtp";
import ChangePassword from "../pages/auth/ChangePassword";
import PromoManagement from "../pages/PromoManagement/PromoManagement";
import ProductDetails from "../pages/ProductDetails/ProductDetails.jsx";
import ApprovalCheck from "../pages/auth/ApprovalCheck.jsx";
import AUCategory from "../pages/ApproveUnapprove/Category/AUCategory.jsx";
import AUSubcategory from "../pages/ApproveUnapprove/Subcategory/AUSubcategory.jsx";
import AUItem from "../pages/ApproveUnapprove/Item/AUItem.jsx";
import AUPromocode from "../pages/ApproveUnapprove/AUPromocode/AUPromocode.jsx";
import AUAdvertisement from "../pages/ApproveUnapprove/Advertisement/AUAdvertisement.jsx";
import AURejected from "../pages/ApproveUnapprove/Rejected/AURejected.jsx";
import AUPromosale from "../pages/ApproveUnapprove/AUPromocode/AUPromosale.jsx";
import AUSubCategoryRejected from "../pages/ApproveUnapprove/Rejected/AUSubCategoryRejected.jsx";
import AUItemRejected from "../pages/ApproveUnapprove/Rejected/AUItemRejected.jsx";
import AUPromocodeRejected from "../pages/ApproveUnapprove/Rejected/AUPromoCodeRejected.jsx";
import AUSaleRejected from "../pages/ApproveUnapprove/Rejected/AUSaleRejected.jsx";
import AUAdvertiseRejected from "../pages/ApproveUnapprove/Rejected/AUAdvertiseRejected.jsx";
import Dispatch from "../pages/Order/Dispatch/Dispatch.jsx";
import BulkChat from "../pages/BulkChat/BulkChat.jsx";
import Orders from "../pages/Earning/Orders/Orders.jsx";
import GIV from "../pages/InventoryManagement/GIV/GIV.jsx";
import GRV from "../pages/InventoryManagement/GRV/GRV.jsx";
import StockLedgerReport from "../pages/InventoryManagement/StockLedgerReport/StockLedgerReport.jsx";
import StockOnHandReport from "../pages/InventoryManagement/StockOnHandReport/StockOnHandReport.jsx";
import NotificationNew from "../components/Notification/Notification.jsx";
import Complaints from "../pages/Complaints/Complaints.jsx";


export const ProtectedRouters = [
  {
    path: "store",
    element: (
      <ProtectedRoute>
        <ErrorBoundary fallback={<ErrorPage />}>
          <Layout />
        </ErrorBoundary>
      </ProtectedRoute>
    ),
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
       {
        path: "notifications",
        element: <NotificationNew/>,
      },
      {
        path: "order/create-order",
        element: <CreateOrder />,
      },
      {
        path: "order/all-orders",
        element: <AllOrder />,
      },
      {
        path: `order/:_id`,
        element: <AllOrder />,
      },
      {
        path: "order/pending-orders",
        element: <PendingOrder />,
      },
      {
        path: "order/accepted-orders",
        element: <AcceptedOrder />,
      },
      {
        path: "order/delivered-orders",
        element: <DeliveredOrder />,
      },
      {
        path: "order/all-return-order",
        element: <ReturnOrder delivery_status={"RETURN_REQUESTED"}/>,
      },
      {
        path: "order/accept-return-order",
        element: <ReturnOrder delivery_status={"ACCEPTED_RETURN"}/>,
      },
      {
        path: "order/pending-return-order",
        element: <ReturnOrder delivery_status={"RETURN_REQUESTED"}/>,
      },
      {
        path: "order/returned-order",
        element: <ReturnOrder delivery_status={"RETURNED"}/>,
      },
      {
        path: "order/cancel-order",
        element: <CancelOrder />,
      },
      {
        path: "order/replacement",
        element: <ReplaceOrder />,
      },
      {
        path: "order/dispatch",
        element: <Dispatch />,
      },
      {
        path: "order/assign-to-deliveryman",
        element: <ReturnOrder delivery_status={"ASSIGNED_TO_DELIVERYMAN"}/>,
      },
      // {
      //   path: "order/store-reviews",
      //   element: <StoreReviews />,
      // },
      // {
      //   path: "order/product-reviews",
      //   element: <ProductReview />,
      // },
      {
        path: "reviews",
        element: <ProductReview />,
      },
      {
        path: "complaints",
        element: <Complaints />,
      },
      {
        path: "product-details/:productId",
        element: <ProductDetails />,
      },

      // {
      //   path: "order/table-booking",
      //   element: <TableBooking />,
      // },

      // {
      //   path: "history/current-week",
      //   element: <HistoryCurrentWeek />,
      // },
      // {
      //   path: "history/current-month",
      //   element: <HistoryCurrentMonth />,
      // },
      // {
      //   path: "history/history-list",
      //   element: <History />,
      // },

      {
        path: "earning/earnings",
        element: <Earning />,
      },
      {
        path: "earning/order",
        element: <Orders />,
      },
      {
        path: "bulkchat/chats",
        element: <BulkChat />,
      },
      {
        path: "earning/current-week",
        element: <CurrentWeek />,
      },
      {
        path: "earning/current-month",
        element: <CurrentMonth />,
      },
      {
        path: "inventory/grv",
        element: <GRV />,
      },
      {
        path: "inventory/giv",
        element: <GIV />,
      },
      {
        path: "inventory/stock-on-hand-report",
        element: <StockOnHandReport />,
      },
      {
        path: "inventory/stock-ledger-report",
        element: <StockLedgerReport />,
      },
      // deliveryBusiness?.name === "Ecommerce"
      //   ? {
      //       path: "menu/item-list",
      //       element: <ItemList />,
      //     }
      //   : {
      //       path: "menu/item-food-list",
      //       element: <ItemFoodList />,
      //     },
      {
        path: "menu/category",
        element: <Category />,
      },
      //   deliveryBusiness?.name === "Ecommerce"?{}
      //   :{
      //   path: "menu/modifier-group",
      //   element: <ModifierCategory />,
      // },
      {
        path: "menu/import-data",
        element: <ImportExportData />,
      },
      {
        path: "users/sub-stores",
        element: <Substore />,
      },
      {
        path: "offers/promocode",
        element: <Offers />,
      },
      {
        path: "offers/sale",
        element: <Sale />,
      },
      {
        path: "Promotion/advertisement-management",
        element: <PromoManagement />,
      },

      // approval/reject routes start
      {
        path: "approvals/category",
        element: <AUCategory />,
      },
      {
        path: "approvals/sub-category",
        element: <AUSubcategory />,
      },
      {
        path: "approvals/item",
        element: <AUItem />,
      },
      {
        path: "approvals/promo-code",
        element: <AUPromocode />,
      },
      {
        path: "approvals/sale",
        element: <AUPromosale />,
      },
      {
        path: "approvals/advertise",
        element: <AUAdvertisement />,
      },
      {
        path: "approvals/category-reject",
        element: <AURejected />,
      },
      {
        path: "approvals/subcategory-reject",
        element: <AUSubCategoryRejected />,
      },
      {
        path: "approvals/item-reject",
        element: <AUItemRejected />,
      },
      {
        path: "approvals/promo-code-reject",
        element: <AUPromocodeRejected />,
      },
      {
        path: "approvals/sale-reject",
        element: <AUSaleRejected />,
      },
      {
        path: "approvals/advertise-reject",
        element: <AUAdvertiseRejected />,
      },
      // approval/reject routes end

      {
        path: "settings/store-settings",
        element: <Storesetting />,
      },
      {
        path: "settings/delivery-settings",
        element: <Deliverysettings />,
      },
      {
        path: "settings/store-time-settings",
        element: <Storetimesettings />,
      },
      {
        path: "settings/table-booking-basic-settings",
        element: <BasicSettings />,
      },
      {
        path: "settings/table-booking-cancellation-policy",
        element: <CancellationPolicy />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "approval-check",
        element: <ApprovalCheck />,
      },
    ],
  },
];

export const publicRouters = [
  {
    path: "/",
    element: (
      <AuthProtected>
        <ErrorBoundary fallback={<ErrorPage />}>
          <Auth />
        </ErrorBoundary>
      </AuthProtected>
    ),
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "verify-otp",
        element: <VerifyOtp />,
      },
      {
        path: "change-password",
        element: <ChangePassword />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
